//格式化日期：yyyy-MM-dd   
function formatDate(date) {
	let myyear = date.getFullYear();//年
	let mymonth = date.getMonth() + 1;//月
	let myweekday = date.getDate();//日
	let myHours = date.getHours(); //时， 
	let myMinutes = date.getMinutes(); //分 
	if (mymonth < 10) {
		mymonth = "0" + mymonth;
	}
	if (myweekday < 10) {
		myweekday = "0" + myweekday;
	}
	if (myHours < 10) {
		myHours = "0" + myHours;
	}
	if (myMinutes < 10) {
		myMinutes = "0" + myMinutes;
	}
	return {
		D: myyear + "/" + mymonth + "/" + myweekday,
		T: myHours * 1 + 8 + ":" + myMinutes,
		myyear,
		mymonth,
		myweekday,
	}
}


function getYearAndMonth(start, end) {
	if(!start && !end)return[];
	var result = [];
	var newResult = [];
	var starts =start ? start.split('-'):[];
	var ends = end?end.split('-'):[];
	var staYear = parseInt(starts[0]);
	var staMon = parseInt(starts[1]);
	var endYear = parseInt(ends[0]);
	var endMon = parseInt(ends[1]);
	while (staYear <= endYear) {
		if (staYear === endYear) {
			while (staMon < endMon) {
				staMon++;
				result.push({ year: staYear, month: staMon });
			}
			staYear++;
		} else {
			staMon++;
			if (staMon > 12) {
				staMon = 1;
				staYear++;
			}
			result.push({ year: staYear, month: staMon });
		}
	}
	for (var i = 0; i < result.length; i++) {
		var year = result[i].year;
		var monthinit = result[i].month;
		if (monthinit < 10) {
			var month = '0' + monthinit;
		} else {
			var month = monthinit + '';
		}
		var ym = year + '' + month + '';
		newResult.push(ym);
	}
	newResult.unshift(start.replace(/-/g, ''));//正则去掉横线
	return newResult
}

export {
	formatDate,
	getYearAndMonth
}


// WEBPACK FOOTER //
// ./src/utils/SetFormat.js